import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MediaGallery from './components/MediaGallery';
import VideoSection from './components/VideoSection';
import SEOHead from '../../components/SEO/SEOHead';
import StructuredData from '../../components/SEO/StructuredData';

const MediaPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://agro-innovazioni.it';
  
  const webPageData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Media - Gallery e Video | AGRO-INNOVAZIONI',
    description: 'Esplora la gallery multimediale di AGRO-INNOVAZIONI. Immagini e video dei nostri prodotti biologici e delle nostre attività.',
    url: `${siteUrl}/media`,
  };

  const imageGalleryData = {
    '@context': 'https://schema.org',
    '@type': 'ImageGallery',
    name: 'Gallery AGRO-INNOVAZIONI',
    description: 'Immagini dei nostri prodotti biologici e attività aziendali',
    url: `${siteUrl}/media`,
  };

  return (
    <>
      <SEOHead
        title="Media - Gallery e Video | AGRO-INNOVAZIONI"
        description="Esplora la gallery multimediale di AGRO-INNOVAZIONI. Immagini e video dei nostri prodotti biologici e delle nostre attività."
        keywords="gallery AGRO-INNOVAZIONI, foto spezie bio, video biscotti bio, immagini prodotti biologici"
        ogTitle="Media - Gallery e Video | AGRO-INNOVAZIONI"
        ogDescription="Esplora la gallery multimediale di AGRO-INNOVAZIONI. Immagini e video dei nostri prodotti biologici e delle nostre attività."
        ogImage="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg"
        ogType="website"
        canonical={`${siteUrl}/media`}
      />
      <StructuredData type="WebPage" data={webPageData} />
      <StructuredData type="WebPage" data={imageGalleryData} />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main className="pt-20">
          <VideoSection />
          <MediaGallery />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default MediaPage;
